


export default function ErrorIcon(){
    return(<i className="fa-solid fa-circle-exclamation" style={{color: "#dd1313"}}></i>)
}